/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BREAKPOINTS; });
/* unused harmony export DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_DOMAIN_DEFAULT; });
/* unused harmony export API_COMMUNITY_DOMAIN */
/* unused harmony export STATIC_DOMAIN_DEFAULT */
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatasWithOption; });
/* unused harmony export handleApiError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(7);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* unused harmony export truthy */
/* unused harmony export falsy */
/* unused harmony export existy */
/* unused harmony export isDefined */
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isObject */
/* unused harmony export isFunction */
/* unused harmony export isRegExp */
/* unused harmony export not */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNotDefined; });
/* unused harmony export parseInt10 */
/* unused harmony export parseStrIntToInt */
/* unused harmony export removeElementInArray */
/* unused harmony export allOf */
/* unused harmony export anyOf */
/* unused harmony export getDefined */
/* unused harmony export notSingleEle */
/* unused harmony export each */
/* unused harmony export getFileExtension */
/* unused harmony export getFirstObjectHasProperty */
/* unused harmony export getObjectHasProperty */
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getResolution; });
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* unused harmony export isMobileResolution */
/* unused harmony export numberWithCommas */
/* unused harmony export getUriParams */
/* unused harmony export getUriCombinedParams */
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* unused harmony export getChangedStats */
/* unused harmony export getPlusElixirPointByLevel */
/* unused harmony export isLevelCanConsumeElixirStat */
/* unused harmony export isLevelGetElixirPoint */
/* unused harmony export getStatMaxByLevel */
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(0);
/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
var getStatMaxByLevel = function getStatMaxByLevel(level, statMaxByLevel) {
  var _statMax = 50;
  each(statMaxByLevel, function (obj) {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_0__model_model__["c" /* PET_NECKLACE_ID */] ? true : false;
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// const singletonId = Symbol();
// const singletonEnforcer = Symbol();

var SettingModel = function SettingModel(options) {
  _classCallCheck(this, SettingModel);

  //constructor(enforcer) {
  //if (enforcer !== singletonEnforcer) throw new Error('SettingModel can not use construct. use getInstance method');

  var _ = this;

  _.isLogin = false;
  _.DEVICE_TYPE = 'pc';
  _.DEFAULT_SERVER_ID = 1;
  _.DEFAULT_GENDER = 'MALE';

  _.ITEM_NAMES = {
    'weapon': '무기',
    'helmet': '투구',
    'armor': '갑옷',
    'cape': '망토 ',
    'gloves': '장갑',
    'boots': '부츠',
    'legging': '각반',
    'shield': '방패/가더',
    'belt': '벨트',
    'necklace': '목걸이',
    'ring': '반지',
    'shoulder': '견갑'
  };
  _.CLASS_NAMES = {
    '0': '군주',
    '1': '기사',
    '2': '요정',
    '3': '마법사',
    '4': '다크엘프',
    '5': '용기사',
    '6': '환술사',
    '7': '전사',
    '8': '검사',
    '9': '창기사',
    '10': '성기사'
  };
  _.ACQUISITION_NAMES = {
    'Quest': '퀘스트',
    'NPC': 'NPC 판매',
    'Making': '제작',
    'Drop': '드랍'
  };
  _.CLASS_MAGIC_POWERBOOK = {
    '0': '/powerbook/wiki/%EA%B5%B0%EC%A3%BC%20%EB%A7%88%EB%B2%95',
    '1': '/powerbook/wiki/%EA%B8%B0%EC%82%AC%20%EA%B8%B0%EC%88%A0',
    '2': '/powerbook/wiki/%EC%A0%95%EB%A0%B9%20%EB%A7%88%EB%B2%95',
    '3': '/powerbook/wiki/%EC%9D%BC%EB%B0%98%20%EB%A7%88%EB%B2%95',
    '4': '/powerbook/wiki/%ED%9D%91%EC%A0%95%EB%A0%B9%20%EB%A7%88%EB%B2%95',
    '5': '/powerbook/wiki/%EC%9A%A9%EA%B8%B0%EC%82%AC%20%EB%A7%88%EB%B2%95',
    '6': '/powerbook/wiki/%ED%99%98%EC%88%A0%EC%82%AC%20%EB%A7%88%EB%B2%95',
    '7': '/powerbook/wiki/%EC%A0%84%EC%82%AC%20%EA%B8%B0%EC%88%A0',
    '8': '/powerbook/wiki/%EA%B2%80%EC%82%AC+%EA%B8%B0%EC%88%A0',
    '9': '/powerbook/wiki/%EC%B0%BD%EA%B8%B0%EC%82%AC+%EA%B8%B0%EC%88%A0',
    '10': '/powerbook/wiki/%EC%84%B1%EA%B8%B0%EC%82%AC%20%EA%B8%B0%EC%88%A0'
  };
  _.BOSS_NAMES = {
    '1': '말하는섬',
    '2': '글루디오 던전',
    '3': '고대 정령의 무덤',
    '4': '풍룡의 둥지',
    '5': '상아탑',
    '6': '오렌 설벽',
    '7': '기란 감옥',
    '8': '용의 계곡',
    '9': '화룡의 둥지',
    '10': '오만의 탑',
    '11': '지배의 탑',
    '12': '사막',
    '13': '기타 필드 보스'
  };

  _.ObjectKeys = function (obj) {
    var keys = [];

    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        keys.push(i);
      }
    }
    return keys;
  };

  _.ObjectValues = function (obj) {
    var values = [];
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        values.push(obj[i]);
      }
    }
    return values;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (SettingModel);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__beginner_BeginnerTop__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__beginner_BeginnerItem__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__beginner_BeginnerMagic__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__beginner_BeginnerHunt__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__beginner_BeginnerRecommend__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_service__ = __webpack_require__(1);










(function ($, global) {
  "use strict";

  Object(__WEBPACK_IMPORTED_MODULE_5__utils_util__["c" /* namespace */])('nc.lineage');

  nc.lineage.beginner = function (options) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__utils_util__["b" /* isNotDefined */])(options)) throw new Error('nc.lineage.beginner require options object');

    var option = $.extend(true, {
      apiDomain: __WEBPACK_IMPORTED_MODULE_6__model_model__["a" /* API_DOMAIN_DEFAULT */],
      classId: 0,
      level: 0,
      wrap: null
    }, options);

    var beginnerTop = new __WEBPACK_IMPORTED_MODULE_0__beginner_BeginnerTop__["a" /* default */](option).init();
    var beginnerItem = new __WEBPACK_IMPORTED_MODULE_1__beginner_BeginnerItem__["a" /* default */](option).init();
    var beginnerMagic = new __WEBPACK_IMPORTED_MODULE_2__beginner_BeginnerMagic__["a" /* default */](option).init();
    var beginnerHunt = new __WEBPACK_IMPORTED_MODULE_3__beginner_BeginnerHunt__["a" /* default */](option).init();
    var beginnerRecommend = new __WEBPACK_IMPORTED_MODULE_4__beginner_BeginnerRecommend__["a" /* default */](option).init();
  };
})(jQuery, window);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tpl__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var BeginnerTop = function () {
  function BeginnerTop(options) {
    _classCallCheck(this, BeginnerTop);

    var _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      classId: 0,
      level: 0,
      global: window
    }, options);

    _.wrap = _.option.wrap;
    _.model = new __WEBPACK_IMPORTED_MODULE_3__tpl__["a" /* default */]();

    _.global = _.option.global ? _.option.global : window;
    _.currentResolution = Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* getResolution */])(__WEBPACK_IMPORTED_MODULE_1__model_model__["b" /* BREAKPOINTS */], window);
  }

  _createClass(BeginnerTop, [{
    key: 'init',
    value: function init() {

      console.log('BeginnerTop !! ');
      var _ = this;

      _.setClass();
      _.setMenu();
      _.setHelper();
      _.setQuickmenu();
      // return _;
    }
  }, {
    key: 'setClass',
    value: function setClass() {
      var _ = this,
          _level = _.option.level,
          _classId = _.option.classId;

      var _className = _.model.CLASS_NAMES[_classId]; // ex. 군주
      var _classMagicPowerbook = _.model.CLASS_MAGIC_POWERBOOK[_classId];
      var _classTypeText = _classId == 1 || _classId >= 7 ? '기술' : '마법';

      console.log('_className : ', _className);
      $('.wrap-section-beginner').removeClass().addClass('wrap-section-beginner class-' + _classId);
      $('.header-class', _.option.wrap.itemWrap).append(_className);
      _classId == 2 ? $('.header-class', _.option.wrap.magicWrap).append(_className + '(바람 계열)') : $('.header-class', _.option.wrap.magicWrap).append(_className);

      $('.btn-magic-powerbook', _.option.wrap.magicWrap).html('<span class="ico-p">powerbook</span><span class="button-class">' + _className + '</span> ' + _classTypeText).attr('href', _classMagicPowerbook); // ex. 군주or성기사 등 마법or기술 파워북


      var dropdown = nc.lineage.dropdown({
        wrap: $('.ui-dropdown-class'),
        activateIndex: _.option.classId + 1,
        activateCallback: function activateCallback(obj) {
          if (obj.index === _.option.classId + 1) return;
          document.location.href = window.getUriCombinedParams(document.location.pathname, {
            classId: obj.index - 1
          });
        },
        useDefaultSelectInMobileDevice: true
      });
    }
  }, {
    key: 'setMenu',
    value: function setMenu() {
      var _ = this;
    }
  }, {
    key: 'setHelper',
    value: function setHelper() {
      var _ = this;

      var _itemHelperHandler = $('.icon-helper', _.option.wrap.itemWrap),
          _magicHelperHandler = $('.icon-helper', _.option.wrap.magicWrap),
          _itemHelperWrap = _itemHelperHandler.siblings('.wrap-helper'),
          _magicHelperWrap = _magicHelperHandler.siblings('.wrap-helper'),
          _wrapItem = _.option.wrap.itemWrap.find('.wrap-helper'); // $('.wrap-helper', _.option.wrap.itemWrap); /*,


      /*let helperInit = setTimeout( function(){
        _itemHelperWrap.fadeOut('fast');
        _magicHelperWrap.fadeOut('fast');
        _itemHelperHandler.removeClass('on');
        _magicHelperHandler.removeClass('on');
      }, 3000 ); */

      _itemHelperHandler.click(function () {
        //clearTimeout(helperInit);
        if (_itemHelperWrap.is(':visible')) {
          _itemHelperWrap.fadeOut('fast');
          _itemHelperHandler.removeClass('on');
        } else {
          _itemHelperWrap.fadeIn('fast');
          _itemHelperHandler.addClass('on');
        }
      });

      _magicHelperHandler.click(function () {
        //clearTimeout(helperInit);
        if (_magicHelperWrap.is(':visible')) {
          _magicHelperWrap.fadeOut('fast');
          _magicHelperHandler.removeClass('on');
        } else {
          _magicHelperWrap.fadeIn('fast');
          _magicHelperHandler.addClass('on');
        }
      });
    }
  }, {
    key: 'setQuickmenu',
    value: function setQuickmenu() {
      var _ = this;

      var _quickmenu = $('.quickmenu');
      var _quickbtn = $('.button-toggle', _quickmenu);
      var _quickitem = $('a', _quickmenu);

      console.log(' _.currentResolution () : ', _.currentResolution);

      if (_.currentResolution == 'pc' || _.currentResolution == 'max') {
        _quickmenu.removeClass('off');
      }

      _quickbtn.click(function (e) {
        e.preventDefault();
        _quickmenu.toggleClass('off');
      });

      _quickitem.click(function (e) {
        e.preventDefault();

        var _section = $(this).attr("class");
        var _itemOffset = $('.wrap-section-' + _section).offset();
        var _quickOffsetTop = _.currentResolution == 'pc' || _.currentResolution == 'max' ? _itemOffset.top - 59 : _itemOffset.top - 106;

        _quickitem.removeClass('on');
        $(this).addClass('on');

        $("html, body").animate({
          scrollTop: _quickOffsetTop
        }, 500);
      });

      $(window).resize(function () {

        _.currentResolution = Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* getResolution */])(__WEBPACK_IMPORTED_MODULE_1__model_model__["b" /* BREAKPOINTS */], window);
        if (_.currentResolution == 'pc' || _.currentResolution == 'max') {
          _quickmenu.removeClass('off');
        } else {
          _quickmenu.addClass('off');
        }

        // console.log( '_currentResolution : ', _.currentResolution );

      });
    }
  }]);

  return BeginnerTop;
}();

/* harmony default export */ __webpack_exports__["a"] = (BeginnerTop);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tpl__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var BeginnerItem = function () {
    function BeginnerItem(options) {
        _classCallCheck(this, BeginnerItem);

        var _ = this;

        if (!options) return;
        _.option = $.extend({
            wrap: null,
            apiDomain: '',
            classId: 0,
            level: 1,
            isLogin: false,
            global: window
        }, options);

        _.model = new __WEBPACK_IMPORTED_MODULE_3__tpl__["a" /* default */]();
        _.global = _.option.global ? _.option.global : window;
    }

    _createClass(BeginnerItem, [{
        key: 'init',
        value: function init() {
            var _ = this;
            console.log('BeginnerItem init !! ');

            _.setData();

            /*
            if (truthy(_.option.isLogin)) {
              if (isDefined(_.option.wrap) && _.option.wrap.length) _.setData();
            }
            return _;
            */
        }
    }, {
        key: 'setData',
        value: function setData() {
            var _ = this,
                _level = _.option.level,
                _classId = _.option.classId;

            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                type: 'GET',
                url: _.option.apiDomain + '/api/returnbrave/recommend/item/' + _classId,
                dataType: 'json'
            }], function (data) {
                _.setInstance(data);
            }, function (data) {
                // no process
            });
        }
    }, {
        key: 'setInstance',
        value: function setInstance(data) {
            var _ = this,
                _level = _.option.level,
                _classId = _.option.classId,
                _wrap = _.option.wrap.itemWrap;
            var _data = data.itemRecommend;

            if (!Object.keys) {
                Object.keys = function (obj) {
                    var keys = [];

                    for (var i in obj) {
                        if (obj.hasOwnProperty(i)) {
                            keys.push(i);
                        }
                    }
                    return keys;
                };
            }

            if (!Object.values) {
                Object.values = function (obj) {
                    var values = [];
                    for (var i in obj) {
                        if (obj.hasOwnProperty(i)) {
                            values.push(obj[i]);
                        }
                    }
                    return values;
                };
            }

            var itemTpl = '';
            var itemTypes = Object.keys(_.model.ITEM_NAMES);
            var itemValues = Object.values(_.model.ITEM_NAMES);

            // 입수법
            var acqTypes = Object.keys(_.model.ACQUISITION_NAMES);
            var itemAcquisitionDisplay = function itemAcquisitionDisplay(acquisition) {

                var acquisitionDom = $('<span class="acq"></span>');

                var acquisitionTpl = '<i class="acq-Quest">Q</i><i class="acq-NPC">N</i><i class="acq-Making">M</i><i class="acq-Drop">D</i>';
                acquisitionDom.append(acquisitionTpl);

                acquisition.map(function (acquisitionItem, acquisitionIdx) {
                    acquisitionDom.find('.acq-' + acquisitionItem).addClass('on');
                });
                return acquisitionDom.html();
            }; // itemAcquisitionDisplay function()


            itemTypes.map(function (item, index) {
                var itemName = _.model.ITEM_NAMES[item]; // ex. 무기

                itemTpl += '<div class="item-card ' + item + '">\n              <h3>' + itemName + '</h3><ul>';

                _data[item].map(function (itemData, itemIndex) {

                    if (itemIndex > 5) return;
                    itemTpl += '<li>\n                        <span class="item-card__name"><a class="grade-' + itemData.itemQuality + '" href="' + itemData.itemWikiUrl + '">' + itemData.itemName + '</a></span>\n                        <span class="item-card__acquisition">' + itemAcquisitionDisplay(itemData.acquisition) + '</span>\n                    </li>\n                ';
                });
                itemTpl += '</ul></div>';
            });
            // console.log('html : ', itemTpl);

            $('.article-item', _wrap).append(itemTpl);

            _.setSlick($('.article-item', _wrap));
        } // setInstance()


    }, {
        key: 'setSlick',
        value: function setSlick(_wrap) {
            var _ = this;

            var itemSlider = _wrap;
            itemSlider.slick({
                dots: true,
                infinite: true,
                arrows: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 3840,
                    settings: "unslick"
                }, {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        centerMode: false,
                        centerPadding: '0'
                    }
                }, {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '40px'
                    }
                }]
            });
            $(window).resize(function () {
                itemSlider.slick('resize');
            });
        } // setSlick()

    }]);

    return BeginnerItem;
}();

/* harmony default export */ __webpack_exports__["a"] = (BeginnerItem);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tpl__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var BeginnerMagic = function () {
  function BeginnerMagic(options) {
    _classCallCheck(this, BeginnerMagic);

    var _ = this;

    if (!options) return;
    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      classId: 0,
      level: 1,
      isLogin: false,
      global: window
    }, options);

    _.model = new __WEBPACK_IMPORTED_MODULE_3__tpl__["a" /* default */]();
    _.global = _.option.global ? _.option.global : window;
  }

  _createClass(BeginnerMagic, [{
    key: 'init',
    value: function init() {
      var _ = this;
      console.log('BeginnerMagic init !! ');

      _.setData();
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _ = this,
          _level = _.option.level,
          _classId = _.option.classId;

      Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
        type: 'GET',
        url: _.option.apiDomain + '/api/returnbrave/recommend/magic/' + _classId,
        dataType: 'json'
      }], function (data) {
        _.setInstance(data);
      }, function (data) {
        // no process

      });
    }
  }, {
    key: 'setInstance',
    value: function setInstance(data) {
      var _ = this,
          _level = _.option.level,
          _classId = _.option.classId,
          _wrap = _.option.wrap.magicWrap;

      var _dataBattle = data.magicRecommend.Battle,
          _dataHunt = data.magicRecommend.Hunt;

      if (!Object.keys) {
        Object.keys = function (obj) {
          var keys = [];

          for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
              keys.push(i);
            }
          }
          return keys;
        };
      }

      if (!Object.values) {
        Object.values = function (obj) {
          var values = [];
          for (var i in obj) {
            if (obj.hasOwnProperty(i)) {
              values.push(obj[i]);
            }
          }
          return values;
        };
      }

      var magicTpl = '',
          magicBattleTpl = '',
          magicHuntTpl = '';

      var magicHuntDom = $('<div class="magic-card  article-magic-hunt"><h3>사냥용</h3></div>');
      var magicBattleDom = $('<div class="magic-card article-magic-battle"><h3>전투용</h3></div>');

      // 입수법
      var acqTypes = Object.keys(_.model.ACQUISITION_NAMES);
      var magicAcquisitionDisplay = function magicAcquisitionDisplay(acquisition) {
        var acquisitionDom = $('<div class="acq"></div>');
        var acquisitionTpl = '<i class="acq-Quest">Q</i><i class="acq-NPC">N</i><i class="acq-Drop">D</i>';
        acquisitionDom.append(acquisitionTpl);

        acquisition.map(function (acquisitionItem, acquisitionIdx) {
          acquisitionDom.find('.acq-' + acquisitionItem).addClass('on');
        });
        return acquisitionDom.html();
      }; // itemAcquisitionDisplay function()


      // magic Battle

      if (_dataBattle.required.length <= 0) {
        magicBattleTpl += '';
      } else {
        magicBattleTpl += '<div class="article-magic-battle-required">\n              <h4 class="battle-required">\uD544\uC218</h4><table><thead><tr><th>\uB9C8\uBC95</th><th>\uC2B5\uB4DD \uB808\uBCA8</th><th>\uD68D\uB4DD \uBC29\uBC95</th><th>\uD328\uC2DC\uBE0C</th></tr></thead><tbody>';
        _dataBattle.required.map(function (item, index) {
          magicBattleTpl += '<tr>\n              <td class="magic-card__name"><a class="grade-' + item.magicQuality + '" href="' + item.magicWikiUrl + '">' + item.magicName + '</a></td>\n              <td class="magic-card__level">' + item.magicLevel + '</td>\n              <td class="magic-card__acquisition">' + magicAcquisitionDisplay(item.acquisition) + '</td>\n              <td class="magic-card__passive">' + (item.magicPassive || '-') + '</td>\n          </tr>';
        });
      }
      magicBattleTpl += '</tbody></table></div>';

      if (_dataBattle.option.length <= 0) {
        magicBattleTpl += '';
      } else {
        magicBattleTpl += '<div class="article-magic-battle-option">\n              <h4 class="battle-option">\uC120\uD0DD</h4><table><thead><tr><th>\uB9C8\uBC95</th><th>\uC2B5\uB4DD \uB808\uBCA8</th><th>\uD68D\uB4DD \uBC29\uBC95</th><th>\uD328\uC2DC\uBE0C</th></tr></thead><tbody>';
        _dataBattle.option.map(function (item, index) {
          magicBattleTpl += '<tr>\n              <td class="magic-card__name"><a class="grade-' + item.magicQuality + '" href="' + item.magicWikiUrl + '">' + item.magicName + '</a></td>\n              <td class="magic-card__level">' + item.magicLevel + '</td>\n              <td class="magic-card__acquisition">' + magicAcquisitionDisplay(item.acquisition) + '</td>\n              <td class="magic-card__passive">' + (item.magicPassive || '-') + '</td>\n          </tr>';
        });
        magicBattleTpl += '</tbody></table></div>';
      }

      // magic Hunt

      if (_dataHunt.required.length <= 0) {
        magicHuntTpl += '';
      } else {
        magicHuntTpl += '<div class="article-magic-hunt-required">\n              <h4 class="hunt-required">\uD544\uC218</h4><table><thead><tr><th>\uB9C8\uBC95</th><th>\uC2B5\uB4DD \uB808\uBCA8</th><th>\uD68D\uB4DD \uBC29\uBC95</th><th>\uD328\uC2DC\uBE0C</th></tr></thead><tbody>';
        _dataHunt.required.map(function (item, index) {
          magicHuntTpl += '<tr>\n              <td class="magic-card__name"><a class="grade-' + item.magicQuality + '" href="' + item.magicWikiUrl + '">' + item.magicName + '</a></td>\n              <td class="magic-card__level">' + item.magicLevel + '</td>\n              <td class="magic-card__acquisition">' + magicAcquisitionDisplay(item.acquisition) + '</td>\n              <td class="magic-card__passive">' + (item.magicPassive || '-') + '</td>\n          </tr>';
        });
        magicHuntTpl += '</tbody></table></div>';
      }

      if (_dataHunt.option.length <= 0) {
        magicHuntTpl += '';
      } else {
        magicHuntTpl += '<div class="article-magic-hunt-option">\n              <h4 class="hunt-option">\uC120\uD0DD</h4><table><thead><tr><th>\uB9C8\uBC95</th><th>\uC2B5\uB4DD \uB808\uBCA8</th><th>\uD68D\uB4DD \uBC29\uBC95</th><th>\uD328\uC2DC\uBE0C</th></tr></thead><tbody>';
        _dataHunt.option.map(function (item, index) {
          magicHuntTpl += '<tr>\n              <td class="magic-card__name"><a class="grade-' + item.magicQuality + '" href="' + item.magicWikiUrl + '">' + item.magicName + '</a></td>\n              <td class="magic-card__level">' + item.magicLevel + '</td>\n              <td class="magic-card__acquisition">' + magicAcquisitionDisplay(item.acquisition) + '</td>\n              <td class="magic-card__passive">' + (item.magicPassive || '-') + '</td>\n          </tr>';
        });
        magicHuntTpl += '</tbody></table></div>';
      }

      magicHuntDom.append(magicHuntTpl);
      magicBattleDom.append(magicBattleTpl);

      $('.article-magic', _wrap).append(magicHuntDom.wrapAll('<div>').parent().html(), magicBattleDom.wrapAll('<div>').parent().html());
    } // setInstance()

  }]);

  return BeginnerMagic;
}();

/* harmony default export */ __webpack_exports__["a"] = (BeginnerMagic);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tpl__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var BeginnerHunt = function () {
    function BeginnerHunt(options) {
        _classCallCheck(this, BeginnerHunt);

        var _ = this;

        if (!options) return;

        _.option = $.extend({
            wrap: null,
            apiDomain: '',
            classId: 0,
            level: 1,
            isLogin: false,
            global: window
        }, options);

        _.model = new __WEBPACK_IMPORTED_MODULE_3__tpl__["a" /* default */]();
        _.global = _.option.global ? _.option.global : window;
    }

    /*  init() {
          const _ = this
          console.log('BeginnerHunt init !! ');
    
        _.setData();
    
      }*/


    _createClass(BeginnerHunt, [{
        key: 'init',
        value: function init() {
            var _ = this,
                _wrap = _.option.wrap.huntWrap;
            console.log('# BeginnerHunt init !! ');

            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                type: 'GET',
                url: _.option.apiDomain + '/conti/getContent?service=lineage&alias=beginner-hunt&lang=ko-KR',
                dataType: 'json',
                contentType: 'application/json',
                Accept: 'application/json'
            }], function (data) {
                console.log('# BeginnerRecommend.js data : ', JSON.parse(data.jsonData));
                if (data.jsonData.length <= 0) {
                    _.setNoData();
                } else {
                    _.setData(JSON.parse(data.jsonData));
                }
            }, function (data) {
                console.log('데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.');
            });
        }
    }, {
        key: 'setNoData',
        value: function setNoData() {
            $(this.option.wrap.recommendWrap).empty().append('<div class="nodata"> - </div>');
        }
    }, {
        key: 'setData',
        value: function setData(data) {
            var _ = this,
                _level = _.option.level,
                _classId = _.option.classId,

            // _data = _.global.huntData.groups,
            _wrap = _.option.wrap.huntWrap;

            _.setInstance(data.groups);

            /*let _lv;
            if( 80 <= _level ) {
                _lv = 4;
            } else if ( 75 <= _level && _level < 80 ) {
                _lv = 3;
            } else if ( 55 <= _level && _level < 75 ) {
                _lv = 2;
            } else {
                _lv = 1;
            }*/
            var _lv = 1;

            $('.tab li', _wrap).removeClass('on');
            $('.table', _wrap).hide();

            $('.tab li:nth-child(' + _lv + ')', _wrap).addClass('on');
            $('#hunt-' + _lv, _wrap).show();

            $('.tab a', _wrap).on('click', function () {
                var _lv = $(this).data('lv');

                $('.tab li', _wrap).removeClass('on');
                $('.table', _wrap).hide();

                $('.tab li:nth-child(' + _lv + ')', _wrap).addClass('on');
                $('#hunt-' + _lv, _wrap).show();
                return false;
            });

            // _.setActive(_lv);
        }
    }, {
        key: 'setInstance',
        value: function setInstance(data) {
            var _ = this,
                _level = _.option.level,
                _classId = _.option.classId,
                _wrap = _.option.wrap.huntWrap;

            var tpl = '';

            console.log('setInstance() data : ', data);

            data.map(function (groups, groupsIndex) {
                var group = groups.items;
                var _idx = groupsIndex + 1;

                tpl += '\n            <table class="table table-size-' + group.length + '" id="hunt-' + _idx + '">\n                <thead>\n                    <tr>\n                        <th class="name thead"><span>\uC0AC\uB0E5\uD130</span></th>';

                group.map(function (item, itemIndex) {
                    tpl += '<th class="name"><a href="' + item.url + '">' + item.name + '</a></th>';
                });
                tpl += '</tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td class="limit thead"><span>\uC785\uC7A5 \uC870\uAC74</span></td>';
                group.map(function (item, itemIndex) {
                    tpl += '<td class="limit">' + item.limit + '</td>';
                });
                tpl += '</tr>\n\t\t\t\t<tr>\n                    <td class="zone thead"><span>\uC9C0\uC5ED \uC124\uC815</span></td>';
                group.map(function (item, itemIndex) {
                    tpl += '<td class="zone">' + item.zone + '</td>';
                });
                tpl += '</tr>\n\t\t\t\t<tr>\n                    <td class="feature thead"><span>\uC8FC\uC694 \uD2B9\uC9D5</span></td>';
                group.map(function (item, itemIndex) {
                    tpl += '<td class="feature">' + item.feature + '</td>';
                });

                tpl += '</tr>\n            </tbody>\n        </table>';
            });

            var tmpl_tab = '\n    <ul class="tab">\n    ' + data.map(function (item, i) {
                return '<li><a href="" data-lv="' + (i + 1) + '">' + item.title + '</a></li>';
            }).join('') + '\n    </ul>\n    ';

            $('.article-tab', _wrap).empty().append(tmpl_tab); // tab
            $('.table-bundle-row', _wrap).empty().append(tpl);
        } // setInstance()


    }]);

    return BeginnerHunt;
}();

/* harmony default export */ __webpack_exports__["a"] = (BeginnerHunt);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BeginnerRecommend = function () {
    function BeginnerRecommend(options) {
        _classCallCheck(this, BeginnerRecommend);

        var _ = this;

        if (!options) return;

        if (!options) return;
        _.option = $.extend({
            wrap: null,
            apiDomain: '',
            classId: 0,
            level: 1,
            isLogin: false,
            global: window
        }, options);

        _.global = _.option.global ? _.option.global : window;
    }

    _createClass(BeginnerRecommend, [{
        key: 'init',
        value: function init() {
            var _ = this,
                _wrap = _.option.wrap.recommendWrap;
            console.log('# BeginnerRecommend init !! ');

            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                type: 'GET',
                url: _.option.apiDomain + '/conti/getContent?service=lineage&alias=beginner-recommend&lang=ko-KR',
                dataType: 'json',
                contentType: 'application/json',
                Accept: 'application/json'
            }], function (data) {
                console.log('# BeginnerRecommend.js data : ', JSON.parse(data.jsonData));
                if (data.jsonData.length <= 0) {
                    _.setNoData();
                } else {
                    _.setData(JSON.parse(data.jsonData));
                    _.setVideoData(JSON.parse(data.jsonData));
                }
            }, function (data) {
                console.log('데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.');
            });
        }
    }, {
        key: 'setNoData',
        value: function setNoData() {
            $(this.option.wrap.recommendWrap).empty().append('<div class="nodata"> - </div>');
        }
    }, {
        key: 'setData',
        value: function setData(data) {
            var _data = data.items;
            var _tmpl = '<section class="section-recommend">\n            <header><h2>\uCD94\uCC9C \uCF58\uD150\uCE20</h2></header>\n            <article>\n                <p class="copy">\uD50C\uB808\uC774\uC5D0 \uB3C4\uC6C0\uC744 \uC904 \uC720\uC6A9\uD55C \uCF58\uD150\uCE20\uB4E4\uC744<br> \uB193\uCE58\uC9C0 \uB9D0\uACE0 \uD655\uC778\uD558\uC138\uC694.</p>\n                <div class="article-recommend">\t\n            ' + _data.map(function (item, index) {
                return '<div class="recommend-card">\n                  <a href="' + item.url + '" class="' + item.target + '">\n                    <dl>\n                      <dd class="recommend-card__thumb"><img src="' + item.img + '"></dd>\n                      <dt class="recommend-card__subject">' + item.subject + '</dt>\n                      <dd class="recommend-card__desc">' + item.desc + '</dd>\n                    </dl>\n                  </a>\n                </div>';
            }).join('') + '\n              </div>\n            </article>\n            </section>';
            $(this.option.wrap.recommendWrap).empty().append(_tmpl);
            this.setSlick();
        }
    }, {
        key: 'setVideoData',
        value: function setVideoData(data) {
            var _data = data.videoItems;
            var _tmpl = '<section class="section-video">\n            <header><h2>\uC601\uC0C1 \uAC00\uC774\uB4DC</h2></header>\n            <article>\n                <ul class="article-video">\t\n            ' + _data.map(function (item, index) {
                return '<li class="video-card">\n                  <a class="btn-video" href="' + item.url + '" target="_blank">' + item.subject + '</a>\n                </li>';
            }).join('') + '\n              </ul>\n            </article>\n            </section>';
            $(this.option.wrap.videoWrap).empty().append(_tmpl);
        }
    }, {
        key: 'setSlick',
        value: function setSlick() {
            var _ = this,
                _wrap = _.option.wrap.recommendWrap;

            var recommendSlider = $('.article-recommend', _wrap);
            recommendSlider.slick({
                dots: true,
                infinite: true,
                arrows: true,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 2,
                responsive: [{
                    breakpoint: 3840,
                    settings: "unslick"
                }, {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }]
            });
            $(window).resize(function () {
                recommendSlider.slick('resize');
            });
        } // setSlick()

    }]);

    return BeginnerRecommend;
}();

/* harmony default export */ __webpack_exports__["a"] = (BeginnerRecommend);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// service/beginner.js